<template><span></span></template>
<script>export default {
    mounted() {
        let embedScript = document.createElement('script');
        embedScript.onload = function() {
            // Pseudo-jQuery for Hubspot callbacks
            (function() {
                window.jQuery = window.jQuery || function(nodeOrSelector) {
                    if (typeof(nodeOrSelector) == 'string') {
                        return document.querySelector(s);
                    }
                    return nodeOrSelector;
                };
            })();
            window.HubSpotForms.create({
                region: "eu1",
                portalId: "139932032",
                formId: "555330e8-78cf-4673-a571-a04ec8b8cc0e",
                target: ".zoezi-60f1327265eeacb9",
                onFormSubmit: function($form) {
                    const email = $form.querySelector('input[name="email"]');
                    const phone = $form.querySelector('input[name="mobilephone"],input[name="phone"]');
                    const firstname = $form.querySelector('input[name="firstname"]');
                    const lastname = $form.querySelector('input[name="lastname"]');
                    const studio = $form.querySelector('select[name="onskad_studio"]');
                    const interest = $form.querySelector('input[name="intresseomrade"]');
					window.dataLayer.push({
                        'event': 'hs_form_submit',
                        'hs-form-guid': $form.getAttribute('data-form-id'),
                        'values': {
                            "email": email ? email.value : null,
                            "phone": phone ? phone.value : null,
                            "address": {
                                "first_name": firstname ? firstname.value : null,
                                "last_name": lastname ? lastname.value : null
                            },
                            "onskad_studio": studio ? studio.value : null,
                            "intresseomrade": interest ? interest.value : null
                        }
                    });
                }
            });
        };
        embedScript.setAttribute('src', '//js-eu1.hsforms.net/forms/embed/v2.js');
        document.head.appendChild(embedScript);
    }
}</script>